export default {
  lineage: null,
  lineageLoading: false,
  startPersonId: null,
};
